import React, { useEffect, useState } from "react";
import "../dashboard.scss";
import { AgGridReact } from "ag-grid-react";
import { academylist, expenditurelist, expenditureview } from "../../../services/admin";
import { useLocation, useNavigate } from "react-router-dom";
import { incexplist } from "../../../services/master";
import { Col, FormGroup, Modal, Row } from "react-bootstrap";
import Select from "react-select";
import moment from "moment";

export default function AllIncome() {
  const [filterProduct, setFilterProduct] = useState([]);
  const [catid, setCatID] = useState(0);
  const [head, setHead] = useState("");
  const [name, setName] = useState("");
  const [invno, setInvNo] = useState("");
  const [idate, setIDate] = useState("");
  const [amt, setAmt] = useState("");
  const [ieurl, setIEUrl] = useState("");
  const [desc, setDesc] = useState("");
  const [alist, setAList] = useState([]);
  const [acaid, setAcaID] = useState("");
  const [acid, setAcID] = useState("");

  const location = useLocation();
  const [urllink, setUrllink] = useState("");

  const columnDefs = [
    {
      headerName: "Actions",
      width: 100,
      field: "id",
      resizable: true,
      filter: false,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              onClick={() => viewshow(params.value)}
              className="btn-sm btn-info me-2"
            >
              <i className="fa fa-eye"></i>
            </a>
          </div>
        );
      },
    },
    {
      headerName: "Income Head",
      field: "head_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Name",
      field: "name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Invoice",
      field: "inv_no",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Date",
      field: "inv_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Amount",
      field: "amount",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Description",
      field: "description",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Academy",
      field: "academy_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

  ];

  const [show, setShow] = useState(false);
  function viewshow(vid) {
    setCatID(vid);
    setAcaID("");
    setHead("");
    setName("");
    setInvNo("");
    setIDate(moment(new Date()).format("YYYY-MM-DD"));
    setAmt("");
    setIEUrl("");
    setDesc("");
    setShow(true);

    expenditureview(vid).then((response) => {
      if (response.status === true) {
        setHead(response.data.details.head_name);
        setName(response.data.details.name);
        setInvNo(response.data.details.inv_no);
        setIDate(moment(response.data.details.inv_date).format("DD-MM-YYYY"));
        setAmt(response.data.details.amount);
        setDesc(response.data.details.description);
        if (response.data.details.attachment !== null) {
          setIEUrl(response.data.path + response.data.details.attachment);
        }
        academylist().then((res) => {
          if (res.status === true) {
            let arr = [];
            if (res.data.details.length > 0) {
              for (let i = 0; i < res.data.details.length; i++) {
                if (res.data.details[i].id === response.data.details.academy_id) {
                  arr.push({
                    value: res.data.details[i].id,
                    label:
                      res.data.details[i].name + " - " + res.data.details[i].code,
                  });
                }
              }
              setAcaID(arr[0]);
            }
          }
        });
      }
    });
  }


  useEffect(() => {
    const path = location.pathname.split("/")[2];
    setUrllink(path);
    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setAList(arr);
        }
      }
    });
    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcID(arr[0]);
                funlist(arr[0], path);
              }
            }

          }
        }
      });
    } else {
      funlist("", path);
    }
  }, [location.pathname]);

  function funlist(fid, ltype) {
    setFilterProduct([]);
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && fid !== "") {
      temp.append("academy_id", fid.value);
    }
    if (ltype === "deleteincome") {
      temp.append("head_type", 1);
    } else if (ltype === "addexpenses") {
      temp.append("head_type", 2);
    }

    expenditurelist(temp).then((res) => {
      if (res.status === true) {
        // setFilterProduct(res.data.delete);
        if(res.data.delete.length > 0){
          const hdata = res.data.delete.map((item) => {
            return {
              ...item,
              inv_date: moment(item.inv_date).format("DD-MM-YYYY"), 
            };
          });
          setFilterProduct(hdata);
        }
       
      }
    });
  }


  function handleAcad(e) {
    if (e !== null) {
      setAcID(e);
      funlist(e, urllink);
    } else {
      setAcID("");
      funlist("", urllink);
    }
  }
  const navigate = useNavigate();
  function handleback() {
    if (urllink === "deleteincome") {
      navigate("/incomeandexpense/addincome");
    } else if (urllink === "deleteexpenses") {
      navigate("/incomeandexpense/addexpenses");
    }
  }

  return (
    <div>
      <div className="page-header">
        <div>
          <h2 className="main-content-title tx-24 mg-b-5">{urllink === "deleteincome" ? "Delete Income" : "Delete Expense"}</h2>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a>Income and Expenses</a></li>
            <li className="breadcrumb-item active" aria-current="page">{urllink === "deleteincome" ? "Delete Income" : "Delete Expense"}</li>
          </ol>
        </div>
      </div>
      <div className="content-body">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <h2 className="main-content-title tx-24 mg-b-5">
                {urllink === "deleteincome" ? "Delete Income" : "Delete Expense"}
              </h2>{" "}
            </div>
            <div className="card-body">
              <div className="row">

                {localStorage.getItem("Role") === "1" && (

                  <div className="col-lg-6 col-md-6">
                    <div className="form-label">
                      <label className="mb-2">
                        Select Academy
                        <span className="text-danger"> *</span>

                      </label>
                    </div>
                    <Select
                      className="default-select"
                      placeholder="Select Academy"
                      value={acid}
                      options={alist}
                      onChange={handleAcad}
                      isSearchable={true}
                      isClearable
                      hidden
                    />
                  </div>


                )}
                <div className="col-lg-6 col-md-6">
                  <div className="responsive">
                    <div className="res-right">
                      <a
                        onClick={handleback}
                        variant="success"
                        type="button"
                        className="btn my-1 me-2 btn-secondary tx-teko"
                      >
                        Back
                      </a>
                    </div>
                  </div>
                </div>
              </div>


              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  columnDefs={columnDefs}
                  rowData={filterProduct}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={["asc", "desc"]}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>
              <Modal show={show}>
                <Modal.Header>

                  {urllink === "deleteincome" && catid !== 0 ?
                    <h4>Income Detail</h4> :
                    urllink === "addexpenses" && catid !== 0 &&
                    <h4>Expense Detail</h4>
                  }

                </Modal.Header>
                <Modal.Body>
                  {localStorage.getItem("Role") === "1" && (
                    <FormGroup className="form-group">
                      <Row className="row-sm">
                        <Col md={4} sm={4}>
                          <label className="Teacherdetail-a">
                            Academy <span className="pull-end">:</span>
                          </label>
                        </Col>
                        <Col md={8} sm={8}>
                          <h6 className="Teacher-detail-b">
                            {acaid.label}
                          </h6>
                        </Col>
                      </Row>
                    </FormGroup>
                  )}
                  <FormGroup className="form-group">
                    <Row className="row-sm">
                      <Col md={4} sm={4}>
                        <label className="Teacherdetail-a">
                          {urllink === "deleteincome" ? "Income Head" : "Expense Head"} <span className="pull-end">:</span>
                        </label>
                      </Col>
                      <Col md={8} sm={8}>
                        <h6 className="Teacher-detail-b">
                          {head}
                        </h6>
                      </Col>
                    </Row>
                  </FormGroup>

                  <FormGroup className="form-group">
                    <Row className="row-sm">
                      <Col md={4} sm={4}>
                        <label className="Teacherdetail-a">
                          Name <span className="pull-end">:</span>
                        </label>
                      </Col>
                      <Col md={8} sm={8}>
                        <h6 className="Teacher-detail-b">
                          {name}
                        </h6>
                      </Col>
                    </Row>
                  </FormGroup>
                  <FormGroup className="form-group">
                    <Row className="row-sm">
                      <Col md={4} sm={4}>
                        <label className="Teacherdetail-a">
                          Invoice Number <span className="pull-end">:</span>
                        </label>
                      </Col>
                      <Col md={8} sm={8}>
                        <h6 className="Teacher-detail-b">
                          {invno}
                        </h6>
                      </Col>
                    </Row>
                  </FormGroup>
                  <FormGroup className="form-group">
                    <Row className="row-sm">
                      <Col md={4} sm={4}>
                        <label className="Teacherdetail-a">
                          Date <span className="pull-end">:</span>
                        </label>
                      </Col>
                      <Col md={8} sm={8}>
                        <h6 className="Teacher-detail-b">
                          {idate}
                        </h6>
                      </Col>
                    </Row>
                  </FormGroup>
                  <FormGroup className="form-group">
                    <Row className="row-sm">
                      <Col md={4} sm={4}>
                        <label className="Teacherdetail-a">
                          Amount <span className="pull-end">:</span>
                        </label>
                      </Col>
                      <Col md={8} sm={8}>
                        <h6 className="Teacher-detail-b">
                          {amt}
                        </h6>
                      </Col>
                    </Row>
                  </FormGroup>
                  <FormGroup className="form-group">
                    <Row className="row-sm">
                      <Col md={4} sm={4}>
                        <label className="Teacherdetail-a">
                          Description <span className="pull-end">:</span>
                        </label>
                      </Col>
                      <Col md={8} sm={8}>
                        <h6 className="Teacher-detail-b">
                          {desc}
                        </h6>
                      </Col>
                    </Row>
                  </FormGroup>

                  <FormGroup className="form-group">
                    <Row className="row-sm">
                      <Col md={4} sm={4}>
                        <label className="Teacherdetail-a">
                          Attachment <span className="pull-end">:</span>
                        </label>
                      </Col>
                      <Col md={8} sm={8}>
                        <div className="form-group">
                          {ieurl.split('.').pop() === "pdf" ? (
                            <a href={ieurl} target="_blank">
                              <img src={require('../../../assets/images/pdf.png')} width="100px" height="100px" />

                            </a>
                          ) : (
                            <img src={ieurl} width="100px" height="100px" />)

                          }
                        </div>
                      </Col>
                    </Row>
                  </FormGroup>
                </Modal.Body>
                <Modal.Footer>
                  <a
                    className="btn btn-next btn-secondary"
                    style={{ float: "right" }}
                    onClick={() => setShow(false)}
                  >
                    Close
                  </a>
                </Modal.Footer>
              </Modal>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
